import { STORED_TOKEN } from '../constants'

export default () => {
  return !!window.sessionStorage.getItem(STORED_TOKEN)
}
